"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    title: "DNS Lookup",
    description: `A simple browser-based tool to perform DNS lookups.<br/>Type a domain, search, and instantly get results.`,
    searchButton: "Search DNS Records",
    textRecords: "Download/Copy Records",
    domain: "Domain name",
};
